import { Box } from '@mui/material';
import ViewWrapper from 'components/core/Layout/ViewWrapper';
import { FormPageHeader } from 'components/inspection/FormPageHeader';
import { inspectionFormFooterSpacerSx } from 'components/inspection/layout';
import { SubmitFooter } from 'components/submitFooter';
import React, { PropsWithChildren } from 'react';

/** Page frame of the company create and edit views, the same as the inspection template wizard. */
export function CompanyWizardPage({
  title,
  isPosting,
  onSubmit,
  onCancel,
  children,
}: PropsWithChildren<{
  title: string;
  isPosting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}>): React.ReactElement {
  return (
    <>
      <ViewWrapper>
        <FormPageHeader title={title} />
        {children}
        <Box sx={inspectionFormFooterSpacerSx} />
      </ViewWrapper>
      <SubmitFooter
        isPosting={isPosting}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </>
  );
}
